import React from 'react';
import { SvgIconWrapper } from './styles';
import { gray50, orange600 } from 'src/colors';

interface SvgIconProps {
  isSelected?: boolean;
  iconPath: string;
  ariaLabel: string;
  size?: string;
  withGradient?: boolean;
}

const IconGradient = () => {
  return (
    <svg
      style={{
        width: 0,
        height: 0,
        visibility: 'hidden',
        position: 'fixed',
      }}
    >
      <linearGradient id="ToolbarIconGradient">
        <stop stopColor="#ff5a00" />
        <stop offset=".5" stopColor="#ff8441" />
        <stop offset="1" stopColor="#ff9a73" />
      </linearGradient>
    </svg>
  );
};

export const SvgIcon: React.FC<SvgIconProps> = ({
  isSelected,
  iconPath,
  ariaLabel,
  size = '',
  withGradient = false,
}) => {
  const fill = !isSelected
    ? gray50
    : withGradient
      ? 'url(#ToolbarIconGradient)'
      : orange600;

  return (
    <>
      {withGradient && isSelected && <IconGradient />}
      <SvgIconWrapper
        src={iconPath}
        key={fill}
        aria-label={ariaLabel}
        size={size}
        preProcessor={(code) => {
          code = code.replace(/filter=".*?"/g, '');
          code = code.replace(/<title>.*<\/title>/g, '');
          code = code.replace(/fill=".*?"/g, `fill="${fill}"`);
          return code;
        }}
      />
    </>
  );
};
